import { useDispatch } from 'react-redux';
import { dialogErrorsUtil } from '../../../../../utils/ErrorHandling/dialogErrorUtil';
import { globalFeedbackUtil } from '../../../../../utils/FeedbackUtils/globalUtils';
import { verifyTotpSetupAPI } from '../../../../../API/services';
import { typeInErrors } from '../../../../../utils/ErrorHandling/errorUtil';
import { authenticatorAppSnackUtil } from '../authenticatorAppSnack.util';
import { fetchUserData } from '../../../../../globalStore/user.thunks';

export const useVerifyTotpSetup = () => {
  const dispatch = useDispatch();

  const handleVerifyTotpSetup = async (params) => {
    const { code, onSuccess = () => {} } = params;

    globalFeedbackUtil.setBackdropIndeterminate({ clickable: false });

    try {
      const response = await verifyTotpSetupAPI({ code }, {}, {});

      if (response.status !== 200) {
        const { errors } = response.data;
        if (typeInErrors(errors, 'USER_TOTP_ALREADY_ENABLED_EXCEPTION')) {
          return authenticatorAppSnackUtil.authenticatorAppAlreadyEnabled();
        }
        if (typeInErrors(errors, 'USER_TOTP_SETUP_NOT_STARTED_EXCEPTION')) {
          return authenticatorAppSnackUtil.authenticatorAppSetupNotStarted();
        }
        if (typeInErrors(errors, 'USER_TOTP_CODE_NOT_VALID_EXCEPTION')) {
          return authenticatorAppSnackUtil.authenticatorAppCodeInvalid();
        }
        dialogErrorsUtil.errorOnServer();
        return;
      }

      await dispatch(fetchUserData()).unwrap();
      onSuccess();
    } catch (error) {
      dialogErrorsUtil.errorOnServer();
    } finally {
      globalFeedbackUtil.closeBackdrop();
    }
  };

  return { handleVerifyTotpSetup };
};
